module.exports = __webpack_public_path__ + "static/media/egypt-quest-mobile.b9acb18f.jpg";